import { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye } from '@fortawesome/pro-solid-svg-icons/faEye'
import { useTranslation } from 'react-i18next'
import CertificateCoursesModal from 'components/reusables/certificateCoursesModal'
import styles from './styles.module.scss'

interface IProps {
  certificateId: number | string
  count: number
  admin?: boolean
  translationKey?: string
}

/**
 * Celda "X cursos" + ojo que abre el modal de cursos asociados (incl. restringidos).
 */
export const CoursesCountCell = ({
  certificateId,
  count,
  admin = false,
  translationKey = 'commons.coursesCount',
}: IProps) => {
  const { t } = useTranslation()
  const [showDetail, setShowDetail] = useState(false)
  const safeCount = count || 0

  if (!safeCount) {
    return <span className={styles.emptyValue}>--</span>
  }

  return (
    <>
      <span
        className={styles.coursesWrapper}
        onClick={() => setShowDetail(true)}
        role="button"
        tabIndex={0}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') setShowDetail(true)
        }}
      >
        {t(translationKey, {
          count: safeCount,
          defaultValue:
            safeCount === 1 ? `${safeCount} curso` : `${safeCount} cursos`,
        })}
        <FontAwesomeIcon icon={faEye} />
      </span>
      {showDetail && (
        <CertificateCoursesModal
          certificateId={certificateId}
          admin={admin}
          close={() => setShowDetail(false)}
        />
      )}
    </>
  )
}

export default CoursesCountCell
